<template>
  <BaseButton
    :class="isIconDisabled ? 'disabled disabled-icon' : ''"
    :disabled="isDisabled"
    :ripple="false"
    color="white"
    retain-focus-on-click
    text
    @click="copyTextHandler()"
  >
    <BaseSpriteIcon icon-name="ico-content-copy"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.copy') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import GoogleAnalyticsUtils from '@/services/utils/GoogleAnalyticsUtils';
import AppConstantsUtil from '@/services/utils/AppConstantsUtil';

import Locator from '@shared/publication/locator.mjs';
import get from 'lodash/get';

export default {
  name: 'CopyTextControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  data() {
    const currentMode = this.$store.getters['ContextStore/appModeGetter'];
    return { currentMode };
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    isSafari() {
      return this.$store.getters['ContextStore/isSafari'];
    },
    isIos() {
      return this.$store.getters['ContextStore/isIos'];
    },
    isDisabled() {
      return this.$attrs.hasOwnProperty('disabled')
        ? this.$attrs.disabled
        : false;
    },
    isIconDisabled() {
      return this.$attrs['icon-disabled'];
    }
  },
  methods: {
    getShortenLink(locator) {
      return this.$store.dispatch('TextCopyStore/getShortenLink', {
        locator,
        bookId: this.bookId
      });
    },
    async $_copyText(event = {}, allowCopy, copyTextRange) {
      const tagName = get(event, 'target.tagName', null);
      const nodeName = get(event, 'currentTarget.body.nodeName', null);
      const isBody = [tagName, nodeName].includes('BODY');
      const isCopyButton =
        event.currentTarget &&
        event.currentTarget.classList &&
        event.currentTarget.classList.contains('context-menu-item');

      if (isBody || isCopyButton || allowCopy) {
        if (this.isSafari || this.isIos) {
          await this.getShortenLink(copyTextRange);
        }
        if (copyTextRange) {
          this.$store.dispatch('TextCopyStore/copySelectedText', {
            locator: copyTextRange,
            bookId: this.bookId,
            event
          });
        }
      }
    },
    async copyTextHandler() {
      try {
        if (this.isIconDisabled) {
          this.$store.dispatch('ManagePopupStore/openToaster', {
            text: this.$t('CopyControl.toaster.disabled.message', {
              paraNum: AppConstantsUtil.MAX_SELECTION_PARAS_NUMBER
            }),
            toasterClose: false
          });
          return;
        }
        GoogleAnalyticsUtils.trackEvent('book', 'contextMenu', 'copy');
        const copyRange = Locator.deserialize(this.selectedLocator.toJSON());
        if (!this.isSafari && !this.isIos) {
          await this.getShortenLink(copyRange);
        }

        let executed = null;
        if (this.isSafari) {
          if (navigator?.clipboard && navigator.clipboard?.writeText) {
            executed = await navigator.clipboard.writeText(
              copyRange?.text?.highlight
            );
          } else {
            executed = document.execCommand('Copy');
          }
        }

        if (!executed) {
          const event = {};
          const allowCopy = true;
          this.$_copyText(event, allowCopy, copyRange);
        }

        this.$store.dispatch('ManagePopupStore/openSuccessToaster', {
          text: this.$t('CopyText.toaster.message')
        });
      } catch {
        const text = this.$t('PresentPublication.error.contextMenu');
        this.$store.dispatch('ManagePopupStore/openErrorToaster', { text });
      }
    }
  }
};
</script>
